export default function isObject(value) {
    return (!!value) && (value.constructor === Object);
}
